:host {
  --uui-multi-select-width: 100%;
  --uui-multi-select-border: 1px solid #000;
  --uui-multi-select-hover-color: var(--uui-theme-core-400);
  --uui-multi-select-active-color: var(--uui-theme-core-600);
  --uui-multi-select-max-height: 300px;
  --uui-multi-select-border-radius: var(--uui-small-gap);
  --uui-multi-select-background-image: url("data:image/svg+xml;utf8,<svg xmlns='http://www.w3.org/2000/svg' height='16px' width='16px' viewBox='0 0 320 512'><path d='M31.3 192h257.3c17.8 0 26.7 21.5 14.1 34.1L174.1 354.8c-7.8 7.8-20.5 7.8-28.3 0L17.2 226.1C4.6 213.5 13.5 192 31.3 192z'/></svg>");
}

:host {
  font-family: var(--uui-primary-font-family);
}

.uui-multi-select__button {
  width: var(--uui-multi-select-width);
  z-index: 1;
}

.selected-value {
  display: block;
  color: var(--uui-theme-secondary-400);
  max-width: 95%;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.uui-multi-select__button:hover {
  border: 1px solid var(--uui-multi-select-hover-color);
}

.uui-multi-select__button:active {
  border: 1px solid var(--uui-multi-select-active-color);
}

.uui-multi-select__button:focus {
  border: 1px solid var(--uui-multi-select-active-color);
}

/** chrome & edge */
.uui-multi-select-dropdown__container::-webkit-scrollbar {
  width: 8px;
  height: 8px;
}

.uui-multi-select-dropdown__container::-webkit-scrollbar-track {
  box-shadow: inset 0 0 6px var(--uui-theme-variant-300);
  border-radius: 4px;
}

.uui-multi-select-dropdown__container::-webkit-scrollbar-thumb {
  background-color: var(--uui-theme-variant-400);
  border-radius: 4px;
}

.uui-multi-select-dropdown__container {
  /* firefox */
  scrollbar-color: var(--uui-theme-variant-400) var(--uui-theme-variant-300);
  scrollbar-width: thin;
  position: absolute;
  top: 30px;
  width: var(--uui-multi-select-width);
  border: var(--uui-multi-select-border);
  list-style-type: none;
  background: #fff;
  box-sizing: border-box;
  max-height: var(--uui-multi-select-max-height);
  overflow-y: auto;
  border-radius: var(--uui-multi-select-border-radius);
  border-top-left-radius: 0;
  border-top-right-radius: 0;
  padding: 0;
  opacity: 1;
  transition: opacity 0.5s ease;
  border: 1px solid var(--uui-multi-select-active-color);
  box-shadow: 0px 12px 24px 0px rgba(128, 128, 128, 0.3);
  z-index: 10;
}

.uui-multi-select-dropdown__expanded .uui-multi-select__button {
  border: 1px solid var(--uui-multi-select-active-color);
}

.uui-multi-select-dropdown__container.hide {
  visibility: hidden;
  opacity: 0;
}

.uui-multi-select__button {
  background-image: var(--uui-multi-select-background-image);
  background-position: calc(100% - 0.75em);
  background-repeat: no-repeat;
  color: inherit;
  border-radius: var(--uui-multi-select-border-radius);
  border: none;
  box-sizing: border-box;
  padding: 0;
  font: inherit;
  cursor: pointer;
  outline: inherit;
  text-align: left;
  border: var(--uui-multi-select-border);
  padding: var(--uui-extra-small-spacing);
  background-color: #fff;
}
.uui-multi-select-dropdown__expanded .uui-multi-select__button,
.uui-multi-select__button:hover {
  box-shadow: 0px 12px 24px 0px rgba(128, 128, 128, 0.3);
}

.uui-multi-select__container {
  position: relative;
  --uui-multi-select-width: 100%;
}
